// 本文件是自动生成, 请勿修改
import base from '@/plugin/base/stage-config'
import blog from '@/plugin/blog/stage-config'
import custom from '@/plugin/custom/stage-config'
import linCmsUi from '@/plugin/lin-cms-ui/stage-config'

const pluginsConfig = [
  base,
  blog,
  custom,
  linCmsUi,
]

export default pluginsConfig
